(() => {
  function initSamteLanding(root) {
    root.querySelectorAll('[data-samte-tabs]').forEach((tabs) => {
      const buttons = tabs.querySelectorAll('[data-tab]');
      const panels = tabs.querySelectorAll('[data-panel]');

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const target = button.getAttribute('data-tab');

          buttons.forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          panels.forEach((panel) => {
            const active = panel.getAttribute('data-panel') === target;
            panel.classList.toggle('is-active', active);
            panel.hidden = !active;
          });
        });
      });
    });

    const animated = root.querySelectorAll('.fade-up, .stagger-up, .img-reveal');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('samte-is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

    animated.forEach((node) => observer.observe(node));

    [
      '.samte-hero-badge',
      '.samte-hero-title',
      '.samte-hero-sub',
      '.samte-hero-desc',
      '.samte-hero-cta',
      '.samte-hero-trust'
    ].forEach((selector, index) => {
      const node = root.querySelector(selector);
      if (!node) return;
      window.setTimeout(() => node.classList.add('samte-is-visible'), 180 + index * 160);
    });

    root.querySelectorAll('[data-samte-quantity-stepper]').forEach((stepper) => {
      if (stepper.dataset.samteQuantityBound === 'true') return;
      stepper.dataset.samteQuantityBound = 'true';

      const input = stepper.querySelector('input[name="quantity"]');
      if (!input) return;

      stepper.querySelectorAll('[data-samte-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const change = parseInt(button.getAttribute('data-samte-quantity-change'), 10) || 0;
          const min = parseInt(input.getAttribute('min'), 10) || 1;
          const max = parseInt(input.getAttribute('max'), 10);
          const current = parseInt(input.value, 10) || min;
          let next = Math.max(min, current + change);

          if (!Number.isNaN(max)) next = Math.min(max, next);

          input.value = next;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });    
  }

  function boot() {
    document.querySelectorAll('.samte-page-section').forEach(initSamteLanding);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => initSamteLanding(event.target));
})();

document.addEventListener('DOMContentLoaded', function () {
  const mainImage = document.getElementById('samte-main-image');
  const thumbs = document.querySelectorAll('.samte-product-thumb');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      // Troca imagem principal
      mainImage.src = this.dataset.full;
      mainImage.alt = this.dataset.alt;

      // Marca thumb ativo
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const counters = document.querySelectorAll('.percentage-number[data-value]');

  const animateCounter = (el) => {
    const target = parseInt(el.dataset.value, 10);
    const duration = 2000; // ms
    const stepTime = 16; // ~60fps
    const steps = Math.ceil(duration / stepTime);
    const increment = target / steps;
    let current = 0;
    let count = 0;

    const timer = setInterval(() => {
      count++;
      current = count >= steps ? target : Math.min(Math.round(increment * count), target);
      el.textContent = current + '%';

      if (count >= steps) clearInterval(timer);
    }, stepTime);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounter(entry.target);
        observer.unobserve(entry.target); // roda só uma vez
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => observer.observe(counter));
});

